import React, { PureComponent, Fragment } from 'react'
import BenzAMRRecorder from 'benz-amr-recorder';
import classnames from 'classnames';

export class AmrPlay extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            playing: false,
            audio: '',
        }
    }

    componentDidMount(prevProps, prevState) {
        let amr = new BenzAMRRecorder();
        this.setState({
            playing: false,
            audio: amr
        })
    }

    playAmr = (amr_url, is_play = "play") => {
        if (is_play === "play") {
            let amr = new BenzAMRRecorder();
            this.setState({ playing: true, audio: amr });
            amr.initWithUrl(amr_url).then(function () {
                amr.play();
            });
            amr.onEnded(function () {
                this.setState({ playing: false });
            }.bind(this))
        }
        else {
            let amr = this.state.audio ? this.state.audio : new BenzAMRRecorder();
            this.setState({ playing: false });
            amr.stop();
        }
    }

    render() {
        const c_content = this.props.c_content;
        return (
            <Fragment>
                <div className="audio_media audio_media_amr">
                    {
                        this.state.playing ?
                            <div className="d-flex">
                                <p className="amrAudio" onClick={() => this.playAmr(this.props.converted_link, "stop")}>
                                    <i className='fa fa-stop'></i>
                                </p>
                                <div id="equalizer" className={classnames(null, { 'left_equalizer': c_content === 'left_content' })}>
                                    <div className="bar"></div>
                                    <div className="bar"></div>
                                    <div className="bar"></div>
                                    <div className="bar"></div>
                                    <div className="bar"></div>
                                    <div className="bar"></div>
                                    <div className="bar"></div>
                                    <div className="bar"></div>
                                    <div className="bar"></div>
                                    <div className="bar"></div>
                                    <div className="bar"></div>
                                    <div className="bar"></div>
                                    <div className="bar"></div>
                                    <div className="bar"></div>
                                </div>
                            </div>
                            :
                            <p className="amrAudio" onClick={() => this.playAmr(this.props.converted_link, "play")}>
                                <i className='fa fa-play'></i>
                            </p>
                    }
                </div>
            </Fragment>
        )
    }
}

export default AmrPlay
